/*
 * Copyright 2019 Atlas Copco. All rights reserved.
 */

export const URL = process.env.REACT_APP_API_HOST + "/api/sales-order?id=";
